import React from 'react';

// Simple "segmentation" icon: two blocks separated by a vertical divider
const SegmentIcon = ({ size = 24, color = 'currentColor' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="6" width="7" height="12" rx="2" />
    <rect x="14" y="6" width="7" height="12" rx="2" />
    <line x1="12" y1="5" x2="12" y2="19" />
  </svg>
);

export default SegmentIcon;


